import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewTabIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 11,
	height: 11,
	viewBox: "0 0 11 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_804_259)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M8.87094 1.27863L6.59199 1.27421V0.0297852H11V4.44268H9.75703L9.7526 2.1612L5.48998 6.42844L4.6084 5.5459L8.87094 1.27863Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M3.9923 0.614258H0.613525V10.3858H10.3744V6.62752",
			stroke: "currentColor",
			strokeWidth: 1.66222,
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_804_259",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 11,
			height: 11,
			fill: "white"
		})
	}) })]
});
export default SvgNewTabIcon;
